import HotelsLoadingAnimation from '@/app/components/HotelsLoadingAnimation'
import classNames from 'classnames'
import { FC } from 'react'
import HotelListItemPlaceholder from './common/HotelListItemPlaceholder'

export interface Props {
	showCount?: boolean
	page?: number
}

const HotelListPlaceholder: FC<Props> = ({ showCount = true, page }) => {
	const items = new Array(10).fill(true)

	return (
		<>
			<div
				className={classNames('hotels-list-placeholder', {
					'px-0': !showCount,
				})}
			>
				<div className="mb-10">
					<HotelsLoadingAnimation />
				</div>
				{showCount ? (
					<div className="hotels-list-placeholder__count"></div>
				) : null}
				{items.map((_, index) => (
					<div key={index} className="mt-5">
						<HotelListItemPlaceholder />
					</div>
				))}
			</div>
		</>
	)
}

export default HotelListPlaceholder
